import {useEffect, useMemo, useState} from 'react';

export const useIsInViewport = <T extends HTMLElement | null>(
	ref: React.MutableRefObject<T>,
): boolean => {
	const [isIntersecting, setIsIntersecting] = useState(false);

	const observer = useMemo(() => {
		if (typeof IntersectionObserver === 'undefined') return;
		return new IntersectionObserver(([entry]) =>
			setIsIntersecting(entry.isIntersecting),
		);
	}, []);

	useEffect(() => {
		if (!observer || !ref.current) return;

		observer.observe(ref.current);

		return () => {
			observer.disconnect();
		};
	}, [ref, observer]);

	return isIntersecting;
};

export const useHasBeenViewed: typeof useIsInViewport = (ref) => {
	const [hasBeenViewed, setHasBeenViewed] = useState(false);
	const inViewPort = useIsInViewport(ref);
	useEffect(() => {
		if (inViewPort) {
			setHasBeenViewed(true);
		}
	}, [inViewPort]);
	return hasBeenViewed;
};
